// extracted by mini-css-extract-plugin
export default {"customHeader":"custom-header_customHeader__BOPsE"};